// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs___ygeY","rotate":"styles_rotate__xLeSo","rotate-reverse":"styles_rotate-reverse__ShM_d"};